import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import StatsTables from './StatsTables';
import Switcher from '../../shared/Switcher';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';
import transformData from './transformData';

const raceTypes = ['flat', 'jumps'];

class Stats extends PureComponent {
    constructor(props) {
        super(props);

        const { statsFlat, statsJumps } = props.data.stats;

        this.raceTypeStats = [
            isEmpty(statsFlat) ? null : transformData(statsFlat.statistics, 'flat'),
            isEmpty(statsJumps) ? null : transformData(statsJumps.statistics, 'jumps'),
        ];

        const selected = (!this.raceTypeStats[0] && this.raceTypeStats[1]) ? 1 : 0;

        this.state = { selected };
    }

    setSelected = (selected) => {
        this.setState({ selected }, () => {
            fixMobileSafariWhiteScreenBug();
        });
    }

    render() {
        const { selected } = this.state;

        return (
            <section className="hp-stats">
                <div className="ui-centered-wrapper">
                    <Switcher
                        items={raceTypes}
                        selected={selected}
                        setSelected={this.setSelected}
                    />
                </div>
                <StatsTables
                    data={this.raceTypeStats[selected]}
                    raceType={raceTypes[selected]}
                />
            </section>
        );
    }
}

Stats.propTypes = {
    data: PropTypes.shape({
        stats: PropTypes.shape({
            statsFlat: PropTypes.oneOfType([
                PropTypes.objectOf(PropTypes.shape({})),
                PropTypes.arrayOf(PropTypes.shape({})),
            ]),
            statsJumps: PropTypes.oneOfType([
                PropTypes.objectOf(PropTypes.shape({})),
                PropTypes.arrayOf(PropTypes.shape({})),
            ]),
        }).isRequired,
    }).isRequired,
};

export default Stats;



// WEBPACK FOOTER //
// ./src/js/horse/stats/Stats.jsx